import { useState } from 'react';
import type { PendingPromptData } from '../types';
import { Button } from './Button';
import { Icon } from './Icon';
import { Markdown } from './Markdown';
import { TextField } from './Field';

const ICON: Record<PendingPromptData['kind'], string> = {
  rendezvous: 'hand',
  clarification: 'message-circle-question',
  question: 'message-circle-question',
  quota: 'battery-low',
};
const TITLE: Record<PendingPromptData['kind'], string> = {
  rendezvous: 'Aspetta te',
  clarification: 'Aspetta un chiarimento',
  question: 'Domanda di un pop',
  quota: 'Quota esaurita',
};

export function PendingPrompt({
  p,
  onAnswer,
  busy,
  freeText = true,
}: {
  p: PendingPromptData;
  onAnswer: (choice: string) => void;
  busy?: boolean;
  /** il campo per una risposta libera; nella sessione si risponde dalla casella in basso */
  freeText?: boolean;
}) {
  const [free, setFree] = useState('');
  return (
    <div
      style={{
        background: 'var(--panel-2)',
        border: '1px solid var(--warn)',
        borderRadius: 'var(--r-xl)',
        padding: 16,
        opacity: busy ? 0.7 : 1,
        pointerEvents: busy ? 'none' : undefined,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <Icon name={ICON[p.kind]} size={16} color="var(--warn)" />
        <span className="t-h3">{TITLE[p.kind]}</span>
      </div>
      {/* la domanda arriva in Markdown (il piano proposto ha titoli ed elenchi): lunga, scorre
          dentro il pannello e i bottoni restano a vista */}
      <div
        className="t-body"
        style={{ marginBottom: 12, maxHeight: '50vh', overflowY: 'auto', paddingRight: 4 }}
      >
        <Markdown text={p.question} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {p.options?.map((o) => (
          <div key={o.label}>
            <Button
              full
              variant={o.recommended ? 'primary' : 'secondary'}
              disabled={o.disabled}
              title={o.disabled ? o.reason : undefined}
              onClick={() => onAnswer(o.label)}
            >
              {o.label}
            </Button>
            {(o.hint || (o.disabled && o.reason)) && (
              <div className="t-caption faint" style={{ marginTop: 4 }}>
                {o.disabled ? o.reason : o.hint}
                {o.recommended && !o.disabled ? ' · consigliata' : ''}
              </div>
            )}
          </div>
        ))}
        {freeText && (
          <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
            <span style={{ flex: 1 }}>
              <TextField
                value={free}
                onChange={setFree}
                placeholder="oppure scrivi la tua risposta"
              />
            </span>
            <Button onClick={() => free.trim() && onAnswer(free.trim())} disabled={!free.trim()}>
              Invia
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
